import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { getReviewsNumber } from '../../utils/getReviewsNumber';
import { IReviewsCounterProps, ReviewsCounter } from '../ReviewsCounter';
import { IReviewsSnippetStarsProps, ReviewsSnippetStars } from '../ReviewsSnippetStars';

export interface IObjectReviewsMiniWidgetProps {
  className?: string;
  ratingClassName?: string;
  reviewsClassName?: string;
  rating?: string | null;
  reviewsCount?: string | null;
  onClick?: VoidFunction;
}

export function ReviewsSnippetRating({
  className,
  ratingClassName,
  reviewsClassName,
  rating,
  reviewsCount,
  onClick,
}: IObjectReviewsMiniWidgetProps) {
  const reviewsCountNumber = getReviewsNumber(reviewsCount);

  const hasRating = rating && rating.length > 0;
  const hasReviewsCount = reviewsCountNumber > 0;

  const ratingProps: IReviewsSnippetStarsProps = {
    className: ratingClassName,
  };
  const reviewsProps: Omit<IReviewsCounterProps, 'children'> = {
    className: cx(styles['reviews'], reviewsClassName),
  };

  if (!hasRating && !reviewsCount) {
    return (
      <div className={cx(styles['root'], styles['no-gap'], className)} onClick={onClick}>
        <ReviewsSnippetStars />
        <ReviewsCounter {...reviewsProps}>Нет отзывов</ReviewsCounter>
      </div>
    );
  }

  if (hasRating && !hasReviewsCount) {
    return (
      <div className={cx(styles['root'], className)} onClick={onClick}>
        <ReviewsSnippetStars isActive {...ratingProps}>
          {rating}
        </ReviewsSnippetStars>
      </div>
    );
  }

  if (!hasRating && hasReviewsCount) {
    return (
      <div className={cx(styles['root'], styles['no-gap'], className)} onClick={onClick}>
        <ReviewsSnippetStars isActive {...ratingProps} />
        <ReviewsCounter {...reviewsProps}>{reviewsCount}</ReviewsCounter>
      </div>
    );
  }

  return (
    <div className={cx(styles['root'], className)} onClick={onClick}>
      <ReviewsSnippetStars isActive {...ratingProps}>
        {rating}
      </ReviewsSnippetStars>
      <ReviewsCounter {...reviewsProps}>{reviewsCount}</ReviewsCounter>
    </div>
  );
}
